import { http, config } from './__http';

export default {
    getProducts(products, params) {
        http.get(config.baseUrl()+'/productgroup/', params).then(response => {
            products(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    getProduct(product, params){
        let color = '';
        if(params.color !== ''){
            color = '?color=' + params.color
        }

      let stockOnly = '';
      if(params.stockOnly !== ''){
        stockOnly = '?stockOnly=' + params.stockOnly
      }

        http.get(config.baseUrl()+'/productgroup/' + params.id + color + stockOnly).then(response => {
            product(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    getProductsAutocomplete(products, params) {
        http.get(config.baseUrl()+'/productgroup/autocomplete', params).then(response => {
            products(response.data);
        }).catch(e => {
            console.error(e);
        });
    },

    getProductAggregations(aggregations, params){
        http.get(config.baseUrl()+'/productgroup/getaggregations', params ).then(response => {
            aggregations(response.data)
        }).catch(e => {
            console.error(e);
        });
    },

    getFastOrderProduct(product, id){
        http.get(config.baseUrl()+'/product/' + id).then(response => {
            product(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
}



// WEBPACK FOOTER //
// ./src/api/Products.js